var _defs, _defs2, _defs3, _defs4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFsiReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f7fa"
    },
    d: "M1872.936 418.208C1170.512 396.877 562.065 921.017 470.139 1608.755c-100.507 751.947 452.674 1428.519 1133.34 1536.882 846.635 134.786 1667.822-644.964 1594.088-1490.877-55.552-637.322-610.604-1214.87-1324.631-1236.552z"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M1530.138 2996.284c37.512-114.311 75.691-288.822 30.996-482.57-51.324-222.476-165.014-266.986-267.092-504.796-145.714-339.467 19.198-585.367-131.648-689.121-73.563-50.596-189.238-50.637-260.556.159-203.474 144.926-147.694 776.19 175.14 1022.526 146.007 111.41 273.416 98.194 382.983 242.362 96.814 127.39 89.222 295.45 70.177 411.44z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 904.199,
    y1: 1295.865,
    x2: 1390.696,
    y2: 2843.808
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e38ddd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571f6"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    style: {
      overflow: "visible",
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    style: {
      clipPath: "url(#c)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M1553.085 2708.653c-12.232-48.07-28.679-95.312-48.885-140.414-46.434-103.641-97.68-160.65-162.56-232.824-42.343-47.106-90.338-100.495-145.8-177.047-103.77-143.22-135.973-193.535-164.829-274.641-57.099-160.489-48.328-304.384-38.021-375.872 14.625-101.411 48.65-197.917 101.135-286.841l3.135 1.852c-52.241 88.51-86.11 184.57-100.665 285.509-10.262 71.157-18.99 214.382 37.847 374.134 28.701 80.675 60.817 130.837 164.345 273.725 55.351 76.395 103.277 129.708 145.56 176.747 65.094 72.413 116.507 129.609 163.175 233.771 20.292 45.291 36.808 92.732 49.09 141.004l-3.527.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m1003.127 1770.348-2.635-1.428c-.603-.327-60.861-33.451-114.405-100.857-49.436-62.238-103.155-167.276-78.319-314.243l3.591.608c-24.613 145.643 28.603 249.713 77.58 311.369 46.758 58.866 98.574 91.302 110.671 98.421 3.345-117.414 78.614-193.498 141.479-236.763 68.573-47.194 137.579-66.552 138.268-66.741l.968 3.51c-.684.189-69.183 19.416-137.257 66.29-62.667 43.151-137.809 119.268-139.889 236.837l-.052 2.997zM1020.304 2147.938c-60.946 0-132.56-14.975-198.697-66.452l2.237-2.874c148.467 115.555 324.999 45.07 342.47 37.628-29.98-115.921-3.465-201.445 24.139-252.85 30.061-55.979 67.941-84.757 68.319-85.04l2.184 2.912c-.373.281-37.706 28.676-67.379 84.004-27.366 51.031-53.632 136.096-23.348 251.56l.387 1.479-1.389.636c-1.093.504-64.859 28.997-148.923 28.997zM1156.262 2369.06c-45.708 0-100.419-8.299-164.078-31.555l1.251-3.421c208.471 76.163 319.947-9.196 331.423-18.7-50.758-118.738 20.722-310.774 21.452-312.705l3.407 1.286c-.728 1.926-72.185 193.929-20.987 311.203l.521 1.195-.963.878c-.798.729-58.667 51.819-172.026 51.819z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M1646.421 2817.071c12.695-76.788 19.992-196.711-42.512-303.959-109.043-187.103-307.8-125.038-498.046-325.492-153.442-161.674-105.086-287.33-275.111-394.776-28.459-17.984-178.834-116.954-290.659-57.343-63.015 33.59-85.846 102.55-90.132 115.496-64.777 195.656 134.513 501.983 394.27 642.088 149.241 80.495 197.39 54.189 460.019 148.07 154.323 55.164 270.193 126.2 342.171 175.916z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 1859.378,
    y1: 5903.974,
    x2: 1745.097,
    y2: 5399.79
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#aa80f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#6165d7"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    style: {
      overflow: "visible",
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    style: {
      clipPath: "url(#f)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M1668.451 2909.514c-38.013-182.594-109.965-305.186-213.854-364.37-50.691-28.877-91.189-33.461-134.066-38.314-46.821-5.298-95.234-10.778-159.273-49.502-62.316-37.683-84.599-73.875-112.812-119.694-25.074-40.723-56.279-91.403-126.294-158.884-61.377-59.157-106.097-86.86-145.553-111.3-43.17-26.741-77.268-47.864-116.852-99.735-64.495-84.511-98.2-192.799-100.181-321.856l3.64-.057c1.969 128.261 35.423 235.825 99.435 319.703 39.176 51.338 73.023 72.305 115.875 98.848 39.611 24.537 84.506 52.347 146.162 111.773 70.346 67.801 101.686 118.7 126.868 159.598 27.953 45.4 50.034 81.26 111.595 118.485 63.356 38.312 111.369 43.746 157.799 49.002 43.258 4.895 84.119 9.52 135.459 38.768 104.835 59.723 177.379 183.13 215.617 366.791l-3.565.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M778.801 2078.701c-133.412 0-233.003-51.133-293.878-95.003-68.578-49.421-104.203-100.589-104.554-101.1l3.001-2.064c.348.505 35.69 51.241 103.8 100.296 62.453 44.979 165.972 97.62 305.147 94.056-8.108-26.016-78.231-262.208 12.004-363.458l2.718 2.421c-93.699 105.139-11.37 359.661-10.527 362.219l.762 2.315-2.437.074a528.06 528.06 0 0 1-16.036.244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M768.553 2295.762c-85.333 0-194.171-17.564-303.375-83.032l1.873-3.125c135.909 81.479 271.276 88.295 360.889 79.664 89.21-8.59 151.945-33.73 162.06-37.987-36.207-133.444-3.967-321.723-3.637-323.618l3.587.627c-.33 1.894-32.68 190.82 3.98 323.554l.417 1.509-1.43.638c-.657.293-66.937 29.494-164.629 38.901a623.667 623.667 0 0 1-59.735 2.869zM884.305 2605.666c-6.508 0-13.075-.071-19.725-.214l.078-3.64c247.108 5.328 395.025-91.212 411.675-102.676-100.251-124.431-60.999-327.689-60.589-329.735l3.57.714c-.408 2.039-39.643 205.292 61.072 328.235l1.216 1.484-1.546 1.136c-1.462 1.075-145.344 104.696-395.751 104.696z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: -33.499,
    y1: 1534.979,
    x2: -1156.846,
    y2: 2457.729,
    gradientTransform: "scale(-1 1) rotate(18.973 -3138.284 6.196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fb6fbb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#g)"
    },
    d: "M1649.097 2751.844c-42.705-30.692-112.604-75.114-206.622-108.444-167.227-59.284-243.863-24.309-314.656-95.006-73.28-73.18-25.815-145.259-113.549-226.979-7.377-6.871-101.579-92.349-186.801-60.519-59.618 22.267-82.832 89.99-93.724 121.766-42.273 123.325-17.693 311.24 113.875 403.928 124.738 87.877 282.665 45.996 332.805 32.344 87.963-23.951 108.809-58.236 198.233-79.917 108.75-26.368 206.496-6.836 270.439 12.827z"
  }), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M2213.503 2827.535c-44.105-97.373-94.577-247.858-73.689-423.288 23.985-201.442 120.138-251.67 187.483-471.528 96.135-313.841-73.134-515.224 50.155-621.347 60.124-51.752 162.298-62.889 230.17-24.864 193.641 108.489 204.949 671.449-56.575 920.023-118.279 112.423-232.09 112.975-315.037 250.836-73.295 121.818-50.461 269.539-22.507 370.168z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 2182.205,
    y1: 2436.983,
    x2: 2639.996,
    y2: 1394.54
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#aa80f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#6165d7"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    style: {
      overflow: "visible",
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      clipPath: "url(#j)"
    },
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m2165.823 2575.695-3.584-.509c6.22-43.836 16.258-87.337 29.837-129.295 31.237-96.517 71.171-151.985 121.729-222.21 32.834-45.602 70.047-97.29 111.6-170.072 77.727-136.132 101.276-183.517 118.884-257.508 34.863-146.523 13.413-272.165-2.474-334.017-22.538-87.742-61.664-169.319-116.287-242.469l2.898-2.167c54.906 73.53 94.236 155.535 116.895 243.734 15.972 62.178 37.531 188.475 2.488 335.756-17.714 74.433-41.334 121.977-119.259 258.466-41.652 72.947-78.925 124.716-111.809 170.392-50.375 69.967-90.164 125.232-121.224 221.208-13.514 41.762-23.506 85.06-29.694 128.691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m2561.223 1694.406-.375-2.955c-13.116-103.605-86.786-163.597-146.275-195.678-64.601-34.836-126.84-45.218-127.462-45.319l.58-3.573c.626.102 63.469 10.583 128.6 45.706 59.656 32.173 133.4 92.108 147.746 195.38 10.458-7.823 52.747-41.405 88.083-97.431 37.277-59.11 74.228-156.053 38.545-282.209l3.485-.986c36.061 127.503-1.333 225.496-39.047 285.249-40.846 64.712-90.928 99.776-91.429 100.122l-2.451 1.694zM2545.184 2031.427c-55.885 0-96.3-13.038-97.137-13.317l-1.442-.481.226-1.502c29.978-200.693-110.83-286.664-112.254-287.509l1.845-3.114c1.442.855 143.607 87.635 114.212 289.622 16.979 5.12 178.954 49.772 298.552-66.106l2.516 2.598c-66.389 64.329-145.632 79.809-206.518 79.809zM2448.216 2239.919c-16.438 0-30.904-1.346-43.285-3.313-50.488-8.025-77.292-27.281-78.409-28.096l-1.046-.765.385-1.237c33.947-108.43-47.562-271.103-48.392-272.734l3.23-1.636c.831 1.636 82.364 164.337 49.014 274.165 11.639 7.638 118.1 71.551 294.233-15.378l1.604 3.245c-72.008 35.54-132.095 45.749-177.334 45.749z"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M2043.385 2847.788c-22.897-82.074-45.02-211.733 10.327-335.851 96.557-216.533 320.219-172.485 503.577-413.152 147.886-194.107 80.398-325.151 252.746-462.198 28.848-22.94 180.81-148.438 309.568-96.781 72.556 29.108 105.56 101.463 111.755 115.046 93.638 205.289-87.045 562.255-353.193 745.458-152.913 105.257-208.429 82.319-483.169 215.552-161.439 78.289-279.151 169.304-351.611 231.926z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 2829.965,
    y1: 1659.873,
    x2: 2421.226,
    y2: 2879.392
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#aa80f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#6165d7"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    style: {
      overflow: "visible",
      fill: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      clipPath: "url(#m)"
    },
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m2030.158 2950.988-3.605-.35c19.895-204.362 84.23-347.209 191.228-424.576 52.389-37.881 96.293-47.742 142.777-58.18 49.933-11.214 101.566-22.811 166.021-72.024 62.639-47.823 82.438-89.482 107.507-142.221 22.567-47.482 50.651-106.572 119.181-188.664 60.066-71.954 105.634-107.525 145.837-138.908 43.515-33.968 77.886-60.799 114.473-121.337 59.773-98.898 83.47-219.963 70.443-359.828l3.605-.336c13.102 140.654-10.769 262.461-70.952 362.037-36.93 61.107-71.535 88.12-115.343 122.318-40.062 31.272-85.464 66.716-145.286 138.373-68.237 81.74-96.212 140.603-118.693 187.899-25.274 53.183-45.243 95.188-108.575 143.545-65.088 49.694-117.114 61.379-167.425 72.678-46.113 10.356-89.666 20.137-141.451 57.583-106.117 76.729-169.957 218.709-189.742 421.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m2880.465 1943.202.506-2.368c.615-2.886 60.129-289.755-54.344-393.164l2.425-2.686c110.413 99.739 61.462 366.199 55.938 394.232 152.164-12.49 258.738-82.189 321.462-138.625 68.312-61.46 100.718-120.784 101.036-121.376l3.188 1.718c-.325.597-33.028 60.472-101.803 122.35-63.466 57.104-171.542 127.701-325.989 139.733l-2.419.186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M2863.309 2180.41c-102.863 0-174.458-22.681-175.19-22.917l-1.481-.477.251-1.536c24.21-148.84-33.35-350.68-33.933-352.702l3.478-1.004c.583 2.022 57.967 203.233 34.276 352.726 11.045 3.306 82.647 23.464 181.223 22.234 98.555-1.223 245.06-24.67 383.337-129.413l2.184 2.884c-139.108 105.374-286.479 128.938-385.613 130.15-2.866.037-5.715.055-8.532.055zM2743.796 2533.082c-90.408 0-163.661-13.081-214.753-26.375-79.176-20.604-123.754-46.181-124.196-46.438l-1.65-.958 1.042-1.598c95.144-145.821 28.363-362.449 27.677-364.621l3.449-1.089c.689 2.179 67.467 218.839-27.038 366.054 18.637 10.08 191.398 98.302 460.485 63.189l.467 3.587c-44.72 5.838-86.684 8.249-125.483 8.249z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 2141.774,
    y1: 607.142,
    x2: 2098.344,
    y2: 981.728,
    gradientTransform: "rotate(25.87 1028.88 3597.401) scale(.9999)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#aa80f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#6165d7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#n)"
    },
    d: "M2062.006 2602.04c50.448-27.746 132.257-66.841 238.823-90.711 189.545-42.458 268.242 5.627 354.476-61.908 89.262-69.907 47.147-154.485 153.242-231.775 8.921-6.498 122.54-87.022 210.981-41.228 61.871 32.037 78.201 108.694 85.864 144.661 29.737 139.594-21.672 340.603-176.852 424.053-147.122 79.118-313.265 12.844-365.966-8.583-92.457-37.592-110.609-77.594-204.952-112.911-114.731-42.949-223.535-34.565-295.616-21.598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8dee8"
    },
    d: "m2588.02 605.037-1341.39-45.401c-30.668-1.038-55.579 22.722-55.579 53.073v2436.664c0 30.351 24.911 53.538 55.579 51.793l1341.39-76.277c27.743-1.578 50.191-26.188 50.191-54.975V658.858c0-28.787-22.448-52.882-50.191-53.821z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8dee8"
    },
    d: "M2037.647 2404.329c-22.813-278.613 148.335-393.612 83.069-646.038-80.673-312.02-390.951-325.393-496.619-631.367-40.487-117.234-56.482-294.467 59.414-552.5l-436.881-14.787c-30.668-1.038-55.579 22.722-55.579 53.073v2436.664c0 30.351 24.911 53.538 55.579 51.793l1196.066-68.013c-304.306-235.623-391.028-457.576-405.049-628.825z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 2578.225,
    y1: 709.521,
    x2: 1588.125,
    y2: 2329.683
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#ebeff2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#o)"
    },
    d: "M2588.02 635.804 1246.63 591.95c-12.571-.411-22.806 9.37-22.806 21.804v2433.82c0 12.434 10.236 21.979 22.806 21.279l1341.39-74.73c11.387-.634 20.643-10.766 20.643-22.586V657.915c0-11.82-9.257-21.739-20.643-22.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d8dee8"
    },
    d: "m2334.68 2478.294-813.928 29.328c-19.214.692-34.81 16.816-34.81 36.013 0 19.196 15.596 34.158 34.81 33.417l813.928-31.365c18.079-.697 32.717-16.33 32.717-34.917 0-18.587-14.638-33.127-32.717-32.476zM2334.68 2598.34l-813.928 32.956c-19.214.778-34.81 16.971-34.81 36.168s15.596 34.089 34.81 33.263l813.928-34.993c18.079-.777 32.717-16.475 32.717-35.062 0-18.589-14.638-33.064-32.717-32.332zM2334.68 2718.385l-813.928 36.584c-19.214.864-34.81 17.126-34.81 36.324 0 19.196 15.596 34.019 34.81 33.107l813.928-38.621c18.079-.858 32.717-16.621 32.717-35.208 0-18.588-14.638-32.998-32.717-32.186zM1912.608 733.243l-409.427-11.596c-9.519-.27-17.24 7.214-17.24 16.716s7.721 17.413 17.24 17.671l409.427 11.089c9.234.25 16.715-7.127 16.715-16.476 0-9.352-7.481-17.143-16.715-17.404zM1912.608 793.591l-409.427-10.693c-9.519-.248-17.24 7.252-17.24 16.754 0 9.501 7.721 17.396 17.24 17.633l409.427 10.186c9.234.23 16.715-7.164 16.715-16.514 0-9.351-7.481-17.125-16.715-17.366zM1912.608 853.938l-409.427-9.79c-9.519-.228-17.24 7.29-17.24 16.792 0 9.501 7.721 17.379 17.24 17.595l409.427 9.283c9.234.209 16.715-7.201 16.715-16.55 0-9.351-7.481-17.109-16.715-17.33z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 1688.501,
    y1: 1121.874,
    x2: 1777.066,
    y2: 1922.505
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffc444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#f36f56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#p)"
    },
    d: "M1754.852 1502.132c26.581-50.286 76.33-86.009 134.624-92.668l4.071-248.494c-166.149 4.343-309.269 106.786-373.387 253.625l234.692 87.537z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 1998.056,
    y1: 1759.532,
    x2: 2352.613,
    y2: 2475.667
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    style: {
      stopColor: "#e38ddd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571f6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#q)"
    },
    d: "M2080.729 1615.136c-14.187 82.561-85.055 145.922-170.836 146.719-25.359.235-49.496-5.024-71.318-14.684l-130.214 214.049c60.194 31.966 128.885 49.434 201.532 48.103 216.015-3.959 390.991-172.996 410.712-385.121l-239.876-9.066z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 1480.658,
    y1: 1471.649,
    x2: 1955.489,
    y2: 2082.146
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#aa80f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#6165d7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#r)"
    },
    d: "m1668.144 1936.849 130.587-214.235c-39.343-32.289-64.5-81.615-64.5-137.028 0-13.389 1.48-26.431 4.266-38.978l-234.972-87.209c-12.375 40.094-19.047 82.714-19.047 126.891 0 146.287 72.924 274.61 183.666 350.559z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 2465.645,
    y1: 935.858,
    x2: 2086.227,
    y2: 1464.956
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fb6fbb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#s)"
    },
    d: "M1936.005 1410.395c78.387 12.212 139.307 77.282 146.581 157.933l396.995 15.689c0-.177.003-.354.003-.532 0-307.684-234.921-563.344-536.827-586.052l-6.752 412.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.35,
      fill: "#fff"
    },
    d: "M2040.733 2404.227c-22.808-278.581 148.301-393.567 83.051-645.965-80.655-311.985-390.862-325.356-496.506-631.295-38.807-112.384-55.11-279.926 45.792-521.076l-423.171-13.835c-12.568-.411-22.801 9.369-22.801 21.802v2433.536c0 12.433 10.233 21.977 22.801 21.277l1159.469-64.595c-274.944-224.935-355.197-435.708-368.635-599.849z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 1647.012,
    y1: 392.168,
    x2: 1032.022,
    y2: 1249.768
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fb6fbb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#t)"
    },
    d: "m1628.34 1232.887-860.046-8.56c-19.449-.193-35.234-15.686-35.234-34.604V862.604c0-18.917 15.786-33.877 35.234-33.414l748.719 17.834c18.415.439 33.326 15.69 33.326 34.066v281.15l78.001 70.647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.67,
      fill: "#fff"
    },
    d: "m1429.531 965.242-569.557-11.105v-39.216l569.557 11.891zM1429.531 1042.101l-569.557-9.532v-39.216l569.557 10.318zM1429.531 1118.96l-569.557-7.959v-39.216l569.557 8.746z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: -7662.869,
    y1: -3102.668,
    x2: -8191.809,
    y2: -2365.063,
    gradientTransform: "rotate(180 -2951 -143.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fb6fbb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#u)"
    },
    d: "m1914.172 2095.803 580.004-12.466c15.098-.324 27.325 12.073 27.325 27.69v270.046c0 15.617-12.227 28.689-27.325 29.198l-611.317 20.605c-15.814.533-28.647-12.01-28.647-28.017V2049.86l59.96 45.943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.67,
      fill: "#fff"
    },
    d: "m1957.449 2324.417 465.045-13.905v32.639l-465.045 14.47zM1957.449 2258.008l465.045-12.774v32.639l-465.045 13.339zM1957.449 2191.599l465.045-11.643v32.639l-465.045 12.208z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 5091.475,
    y1: 3758.071,
    x2: 5139.617,
    y2: 3800.894,
    gradientTransform: "rotate(-8.047 114.958 19378.959)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444b8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#26264f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#v)"
    },
    d: "M2869.323 3237.155c1.37-7.547 25.742-14.379 37.81-4.269 5.993 5.019 10.119 15.193 6.652 19.789-1.262 1.671 3.905 4.612-1.045 4.669-16.418.191-44.78-12.689-43.417-20.189z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    gradientUnits: "userSpaceOnUse",
    x1: 4924.029,
    y1: 3538.705,
    x2: 4924.029,
    y2: 3454.838,
    gradientTransform: "rotate(2.854 9694.002 -37098.464)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffc444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#f36f56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#w)"
    },
    d: "m2895.974 3237.196 25.284 1.261c-8.759-15.925 1.772-59.24 1.772-59.24l-27.302.802s.672 12.575 2.336 31.254c.571 6.394-.48 16.027-2.09 25.923z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientUnits: "userSpaceOnUse",
    x1: 5096.315,
    y1: 3752.632,
    x2: 5144.456,
    y2: 3795.453,
    gradientTransform: "rotate(-8.047 114.958 19378.959)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444b8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#26264f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#x)"
    },
    d: "M2892.646 3236.814s30.177-6.953 33.441-.967c3.265 5.987 5.799 22.014-13.347 21.497-19.147-.516-21.795-15.454-20.094-20.53z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    gradientUnits: "userSpaceOnUse",
    x1: 5148.002,
    y1: 3268.434,
    x2: 5196.146,
    y2: 3311.258,
    gradientTransform: "translate(-2609.08)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444b8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#26264f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#y)"
    },
    d: "M2549.276 3291.896c2.413-7.28 27.502-10.633 38.037 1.065 5.229 5.807 7.892 16.459 3.816 20.523-1.483 1.48 3.22 5.115-1.689 4.479-16.282-2.108-42.562-18.833-40.164-26.067z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    gradientUnits: "userSpaceOnUse",
    x1: 4965.955,
    y1: 2995.54,
    x2: 4965.955,
    y2: 2911.67,
    gradientTransform: "rotate(11.098 2140.231 -9080.372)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffc444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#f36f56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#z)"
    },
    d: "m2578.924 3298.909 24.84 4.875c-6.384-17.017 10.253-58.372 10.253-58.372l-27.134-3.124s-1.14 12.542-2.171 31.267c-.354 6.409-2.775 15.792-5.788 25.354z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 5152.842,
    y1: 3262.994,
    x2: 5200.985,
    y2: 3305.817,
    gradientTransform: "translate(-2609.08)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444b8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#26264f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#A)"
    },
    d: "M2572.417 3294.823s30.854-2.661 33.248 3.725c2.394 6.383 2.661 22.607-16.225 19.416-18.885-3.192-19.418-18.354-17.023-23.141z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 2800.635,
    y1: 2805.024,
    x2: 2999.566,
    y2: 2805.024
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6b3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#B)"
    },
    d: "M2800.635 2424.556a8273.97 8273.97 0 0 0 29 360.463 8257.244 8257.244 0 0 0 52.882 412.993c24.824 8.513 47.765 0 47.765 0s29.025-47.541 51.177-173.892c14.212-81.072 15.193-80.05 15.353-94.191.803-71.35-24.228-92.006-29-155.778-4.415-59.003 14.366-76.674 25.588-143.098 8.629-51.078 11.865-125.514-15.353-222.799l-177.412 16.302z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 2800.635,
    y1: 2805.024,
    x2: 2983.363,
    y2: 2805.024
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6b3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#C)"
    },
    d: "M2800.635 2424.556a8272.488 8272.488 0 0 0 29 360.462 8257.244 8257.244 0 0 0 52.882 412.993c24.824 8.513 47.764 0 47.764 0a597.136 597.136 0 0 0-3.692-52.456c-6.715-58.529-17.417-75.182-18.516-111.098-1.405-45.933 15.226-47.347 18.516-92.581 5.1-70.112-33.398-86.739-37.032-148.13-3.84-64.866 36.776-86.212 67.893-166.647 18.368-47.481 34.672-118.769 20.597-218.846l-177.412 16.303z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 3168.634,
    y1: 2941.177,
    x2: 2621.376,
    y2: 2842.424
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    style: {
      stopColor: "#5c3169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6b3976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#D)"
    },
    d: "M2676.107 2420.933c-33.99 114.498-66.931 256.717-85.293 422.049a2441.348 2441.348 0 0 0-10.235 420.238l32.411 9.057c62.823-65.73 85.253-126.144 93.824-170.269 12.679-65.271-6.425-87.404 10.235-161.213 3.833-16.979 9.225-35.215 71.646-157.589 59.577-116.796 71.792-133.76 81.882-175.703 14.403-59.871 10.604-112.967 5.118-148.533-66.53-12.677-133.058-25.357-199.588-38.037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26264f"
    },
    d: "m2408.215 2173.462-106.606-249.723c-5.327-12.477 1.826-26.749 15.008-29.952l195.28-47.425c10.554-2.563 21.396 2.977 25.503 13.031l98.055 240.015c4.883 11.952-1.553 25.517-13.899 29.295l-186.728 57.133c-10.73 3.282-22.207-2.055-26.613-12.374z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 2492.764,
    y1: 2021.524,
    x2: 2242.621,
    y2: 1932.763
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffc444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    style: {
      stopColor: "#f78e50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#f36f56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#E)"
    },
    d: "m2413.04 2161.451-99.579-233.26c-4.974-11.653 1.706-24.986 14.02-27.976l182.406-44.298c9.858-2.394 19.984 2.78 23.821 12.171l91.59 224.191c4.561 11.164-1.45 23.833-12.983 27.363l-174.417 53.366c-10.021 3.067-20.742-1.918-24.858-11.557z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    gradientUnits: "userSpaceOnUse",
    x1: 2354.56,
    y1: 2002.973,
    x2: 2325.133,
    y2: 2137.311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffc444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#f36f56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#F)"
    },
    d: "m2351.565 2092.881-3.199-29.426-16.955-32.321a30.7 30.7 0 0 1-3.515-14.268v-32.095l20.47 47.339s13.434-12.155 18.552-14.714c5.117-2.559 4.478 7.676.64 11.515-3.839 3.837 1.919 35.183-1.919 38.382l1.279 19.191-15.353 6.397z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 2506.69,
    y1: 2170.838,
    x2: 3061.721,
    y2: 2170.838
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fb6fbb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#G)"
    },
    d: "M2514.049 1905.448c15.919-38.928 50.089-61.316 67.808-72.926 41.925-27.469 68.765-22.454 165.043-37.103 128.311-19.523 143.669-38.022 186.793-23.029 56.646 19.693 86.235 71.113 99.793 94.676 68.356 118.793-11.563 179.172 8.956 415.807 8.379 96.642 29.865 180.624-21.75 230.292-10.868 10.458-23.024 15.927-47.338 26.868-96.424 43.386-182.876 35.907-235.411 30.706-57.807-5.724-87.024-9.002-102.352-29.427-24.484-32.625.72-74.09 5.118-145.852 3.158-51.521-8.557-92.348-31.985-173.999-54.464-189.823-125.175-241.432-94.675-316.013z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    gradientUnits: "userSpaceOnUse",
    x1: 5961.474,
    y1: 1118.099,
    x2: 6173.767,
    y2: 1385.191,
    gradientTransform: "rotate(14.927 2153.721 -10935.644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffc444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#f36f56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#H)"
    },
    d: "M2728.821 1725.396c-5.842-20.811 4.371-40.084 6.622-44.237 9.424-17.386 11.839-19.761 16.335-22.772l6.251-3.856s.362-.145.743-.281c4.011-1.428 17.682-1.843 20.452-1.251 8.847 1.889 18.267 37.933 15.579 88.891a392.168 392.168 0 0 1 4.419 29.523c.818 7.377 11.279 7.208 18.687 6.735 30.066-1.919 44.779.64 46.059 5.117 2.397 8.391-33.265 35.824-77.3 41.995-59.098.44-107.173-5.853-102.006-15.159 2.295-4.132 48.084-16.097 60.962-27.955 11.791-10.86 10.83-22.07 11.8-30.096-3.575-1.856-24.304-11.322-28.603-26.654z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26264f"
    },
    d: "M2739.69 1640.055c.052 15.787 7.491 32.647 11.281 35.357.489.35 3.244 2.526 5.718 6.246.337.506.635 1.099.899 1.866 3.458 9.948-12.36 21.655-9.307 26.111 2.215 3.231 12.966-1.09 14.244 1.701 1.204 2.625-7.73 8.064-6.362 11.209 1.032 2.375 6.53.203 9.998 3.84 1.729 1.812 1.221 3.247 3.053 8.786 1.035 3.132 2.483 6.559 3.606 8.466 5.457 9.27 20.909 12.656 23.883 8.946.827-1.035.116-1.903.962-5.372 0 0 .783-3.215 3.021-6.932 3.196-5.312 10.912-9.11 18.698-14.716 14.418-10.383 18.337-19.234 19.513-22.224.418-1.065.678-1.869.866-2.448 3.749-11.636 3.766-28.728-1.465-39.24-8.763-17.608-28.533-9.248-44.714-26.695-18.671-20.129-7.551-47.643-17.683-50.682-11.165-3.351-36.307 26.59-36.211 55.781z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    gradientUnits: "userSpaceOnUse",
    x1: 5935.086,
    y1: 1058.673,
    x2: 6172.118,
    y2: 1356.889,
    gradientTransform: "rotate(14.927 2153.721 -10935.644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffc444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#f36f56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#I)"
    },
    d: "M2753.957 1705.923c3.87-5.317 10.668-.321 10.708 6.558.041 6.878-6.625 14.03-13.092 12.672-6.466-1.358-2.823-12.073 2.384-19.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26264f"
    },
    d: "m2757.095 1694.415-8.976 11.678s-9.677 14.306-15.327 6.469c-4.615-6.404-5.812-6.262-6.094-5.993-.053.05-.068.128-.081.124-.081-.022.677-3.188 1.358-5.97-2.389 3.43-5.683 8.995-7.677 16.482-1.937 7.272-4.013 15.058.09 22.538.237.432 4.757 8.393 13.197 10.319 0 0 3.319.757 17.342-1.707 0 0-15.327-11.122-15.563-13.765-.635-7.185 9.329-11.067 16.727-25.797a59.213 59.213 0 0 0 5.004-14.378z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    gradientUnits: "userSpaceOnUse",
    x1: 2494.82,
    y1: 2122.987,
    x2: 2835.141,
    y2: 2447.956
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fb6fbb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#J)"
    },
    d: "M2787.842 2502.929c-17.007-33.863 24.667-78.876-2.559-130.499-23.123-43.844-65.127-34.022-84.44-74.206-23.327-48.535 27.405-84.809 25.588-158.646-2.172-88.27-78.124-176.63-122.822-168.881-28.92 5.013-32.636 48.158-52.984 95.392 18.005 39.482 39.042 88.946 58.101 155.371 23.428 81.651 35.143 122.478 31.985 173.999-4.398 71.761-29.602 113.227-5.118 145.852 15.328 20.425 44.545 23.703 102.352 29.427 52.535 5.201 138.987 12.68 235.411-30.706 12.205-5.492 21.342-9.605 28.795-13.663-150.645 22.623-200.82 3.42-214.309-23.44z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    gradientUnits: "userSpaceOnUse",
    x1: 2345.255,
    y1: 2039.384,
    x2: 2648.639,
    y2: 2039.384
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fb6fbb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#K)"
    },
    d: "m2345.808 2087.123 28.147-12.154c15.857 16.218 36.082 31.987 53.095 26.866 25.36-7.631 19.019-54.285 49.896-136.256 34.986-92.876 74.681-116.749 94.676-125.381 11.168-4.822 18.879-8.023 28.147-5.758 42.646 10.425 56.745 121.553 44.779 204.705-6.742 46.849-19.961 138.711-95.316 182.315-10.704 6.195-69.627 40.291-127.94 13.434-49.817-22.943-80.599-81.808-75.484-147.771z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    gradientUnits: "userSpaceOnUse",
    x1: 2281.07,
    y1: 1272.323,
    x2: 1778.378,
    y2: 1875.552
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#L)"
    },
    d: "m1791.563 1760.978 508.614-417.313 2.656 1.293-504.606 427.462z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    gradientUnits: "userSpaceOnUse",
    x1: 1863.486,
    y1: 1706.077,
    x2: 1610.781,
    y2: 1937.043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffc444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#f36f56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#M)"
    },
    d: "m1760.494 1788.727 19.912-21.748 10.365-23.98a25.638 25.638 0 0 1 8.268-10.428l5.95-4.414a19.805 19.805 0 0 1 11.799-3.898h19.525s-3.402 6.366-8.943 7.339c-5.542.974-17.126 14.05-17.126 14.05l-1.575 15.33 22.153-16.171 23.613-27.139v15.066a21.464 21.464 0 0 1-5.224 14.032l-19.155 22.166a30.749 30.749 0 0 1-18.379 10.253l-4.724.76a36.288 36.288 0 0 0-24.189 15.345l-13.47 19.703-8.8-26.266z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    gradientUnits: "userSpaceOnUse",
    x1: 633.769,
    y1: 2699.294,
    x2: 693.548,
    y2: 2299.859
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffc444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#f36f56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#N)"
    },
    d: "M685.605 2511.316s-5.52 25.957-10.325 47.819c-4.805 21.862-24.028 38.63-32.439 56.076-8.409 17.448-12.187-2.977-14.502-15.592-2.317-12.615 0-38.66 10.408-47.576 10.409-8.916 18.32-16.7 17.815-18.501-.504-1.802 6.684-31.838 6.684-31.838l22.359 9.612z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    gradientUnits: "userSpaceOnUse",
    x1: 959.465,
    y1: 3397.444,
    x2: 910.554,
    y2: 3109.415
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#aa80f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#6165d7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#O)"
    },
    d: "M916.327 3291.647c-1.311-5.408-.431-12.641 4.283-17.493 6.355-6.539 16.995-5.986 23.674-2.96 3.893 1.761 6.919 4.58 17.613 26.88 11.303 23.569 11.254 27.369 9.435 29.519-3.698 4.373-14.069 1.147-16.303.451-7.431-2.309-9.246-5.833-24.553-20.168-10.378-9.718-12.954-11.293-14.149-16.229z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse",
    x1: 930.568,
    y1: 3285.637,
    x2: 946.872,
    y2: 3115.355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffc444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#f36f56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#P)"
    },
    d: "m923.555 3254.808 2.59 27.318c6.222 3.235 10.084 2.974 12.119 0l5.222-27.318h-19.931z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    gradientUnits: "userSpaceOnUse",
    x1: 1226.402,
    y1: 3352.113,
    x2: 1177.492,
    y2: 3064.09
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#aa80f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#6165d7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#Q)"
    },
    d: "M1184.774 3288.234c-3.657-4.195-6.208-11.02-4.261-17.498 2.625-8.73 12.321-13.145 19.644-13.539 4.266-.23 8.251.876 28.021 15.737 20.892 15.707 22.602 19.102 21.978 21.848-1.266 5.584-11.956 7.501-14.261 7.914-7.657 1.377-10.894-.914-31.085-6.581-13.687-3.841-16.699-4.052-20.036-7.881z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    gradientUnits: "userSpaceOnUse",
    x1: 1190.056,
    y1: 3310.481,
    x2: 1206.359,
    y2: 3140.205
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffc444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#f36f56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#R)"
    },
    d: "m1186.588 3242.613 2.591 27.317c6.221 3.235 10.084 2.973 12.119 0l5.222-27.317h-19.932z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    gradientUnits: "userSpaceOnUse",
    x1: 979.449,
    y1: 3263.411,
    x2: 1233.058,
    y2: 2310.566
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444b8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#26264f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#S)"
    },
    d: "M916.564 3260.155c9.828.594 19.657 1.183 29.486 1.778a10620.094 10620.094 0 0 1 154.62-649.645 1650.683 1650.683 0 0 1 25.998 144.683c10.863 81.034 13.061 143.123 13.587 160.317 2.681 87.902-4.981 98.283-1.359 153.163 2.848 43.148 12.193 106.542 43.476 183.537 9.369-.573 18.74-1.136 28.109-1.704 20.507-99.2 38.081-219.751 43.047-357.445a2155.844 2155.844 0 0 0-27.679-430.551c-85.141 2.643-170.281 5.292-255.42 7.935-26.577 59.338-38.685 110.079-44.822 145.759-12.334 71.705-4.77 107.087-14.051 229.252-4.797 63.134-8.298 73.147-11.774 115.079-5.765 69.438-6.766 169.727 16.782 297.842z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    gradientUnits: "userSpaceOnUse",
    x1: 895.945,
    y1: 3241.185,
    x2: 1149.554,
    y2: 2288.34
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444b8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#26264f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#T)"
    },
    d: "M973.143 3017.826c7.768-82.552-22.017-80.849-8.151-152.166 12.759-65.617 39.818-76.55 59.779-160.318 16.021-67.235 3.784-81.984 16.304-111.406 15.468-36.354 60.649-76.039 190.518-92.901-1.86-12.546-3.77-24.847-5.745-36.747-85.141 2.643-170.28 5.292-255.42 7.935-26.577 59.338-38.685 110.079-44.822 145.759-12.333 71.705-4.77 107.087-14.051 229.252-4.797 63.134-8.296 73.147-11.774 115.079-5.762 69.438-6.762 169.727 16.785 297.841 9.828.594 19.658 1.183 29.486 1.778.605-2.951 1.252-5.95 1.861-8.905-4.962-8.047-9.474-17.084-12.81-27.333-21.559-66.232 28.334-104.697 38.04-207.868z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    gradientUnits: "userSpaceOnUse",
    x1: 1441.425,
    y1: 1686.829,
    x2: 876.239,
    y2: 2434.071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffc444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#f36f56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#U)"
    },
    d: "M651.151 2516.495c12.68 2.266 25.361 4.526 38.041 6.792a2274.73 2274.73 0 0 0 31.444-103.525c14.001-50.355 21.19-82.898 24.259-94.833 12.205-47.489 47.893-114.119 153.078-195.228-1.045 51.6-1.855 94.053-2.4 123.22-4.374 234.017-4.122 276.496 26.962 299.831 27.029 20.288 41.958-.477 164.736 1.857 111.974 2.128 135.542 20.082 163.977-.477 46.145-33.367 28.221-112.58 28.944-211.542.597-81.666 14.039-197.229 73.366-338.297 43.68 4.24 116.724 5.398 199.717-23.097 128.893-44.251 202.136-132.657 229.608-169.827l-27.172-36.682c-46.348 20.23-117.978 46.936-208.415 61.716-156.775 25.617-228.85-7.684-374.434-1.937-83.847 3.312-255.098 10.073-370.904 97.822-212.968 161.363-158.447 536.007-150.807 584.207z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    gradientUnits: "userSpaceOnUse",
    x1: 1456.704,
    y1: 1698.384,
    x2: 891.516,
    y2: 2445.628
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffc444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#f36f56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#V)"
    },
    d: "M1057.378 2489.323c-6.482-36.147 12.986-51.369 2.717-92.387-14.49-57.884-60.96-58.33-72.007-107.33-10.534-46.73 28.475-60.756 38.042-134.504 7.032-54.218-2.9-132.594-39.399-145.373-45.408-15.895-112.145 76.667-119.559 86.952-25.656 35.584-40.565 72.33-49.29 105.165 20.774-22.517 46.978-46.612 80.092-72.144-1.045 51.6-1.854 94.053-2.4 123.22-4.374 234.017-4.122 276.496 26.963 299.831 27.028 20.288 41.958-.477 164.735 1.857 3.51.069 6.684.191 10.023.287-26.526-24.28-36.589-47.015-39.917-65.574z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    gradientUnits: "userSpaceOnUse",
    x1: -824.078,
    y1: 2470.944,
    x2: -824.078,
    y2: 2264.455,
    gradientTransform: "scale(-1 1) rotate(34.208 -.302 1669.756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffc444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#f36f56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#W)"
    },
    d: "M1125.585 1736.721s-4.987 39.672-19.737 68.501c-13.329 26.051-73.435 38.285-85.826 43.345-12.39 5.061 20.42 25.386 54.508 31.596 34.087 6.209 132.85 6.27 151.584-5.341 18.735-11.609-13.25-13.185-37.057-24.155s-34.145-60.076-28.071-81.502c6.074-21.427-35.401-32.444-35.401-32.444z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    gradientUnits: "userSpaceOnUse",
    x1: -2917.621,
    y1: 957.889,
    x2: -2985.839,
    y2: 784.628,
    gradientTransform: "scale(-1 1) rotate(5.716 -11007.703 19583.732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444b8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#3e4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#X)"
    },
    d: "M1189.003 1721.997c8.088-13.679 2.93-38.475-12.912-49.144-11.755-7.917-25.231-5.247-35.05-3.302-4.545.901-36.465 7.624-43.776 31.297-2.323 7.525-1.362 17.474 2.039 25.174 1.753 3.965 5.017 8.841 12.195 18.1 6.37 8.214 5.955 7.946 7.902 10.33 4.672 5.725 13.612 15.305 29.638 26.115.629-4.393 1.702-9.854 3.666-15.855.756-2.308 3.815-11.339 9.009-19.084 10.549-15.721 20.966-12.935 27.289-23.631z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    gradientUnits: "userSpaceOnUse",
    x1: -970.037,
    y1: 2489.786,
    x2: -873.496,
    y2: 2302.068,
    gradientTransform: "scale(-1 1) rotate(34.208 -.302 1669.756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffc444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#f36f56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#Y)"
    },
    d: "M1128.73 1770.182s17.233 22.979 46.675 18.199c26.361-4.281 24.52-64.143 6.36-75.136-6.058-3.668-17.547-4.326-26.504-.86-5.293 2.046-6.915 4.484-15.624 7.662-8.032 2.929-10.449 2.239-12.734 4.573-2.86 2.917-4.519 9.555 2.349 26.448-5.553-4.641-11.818-6.021-15.926-3.574-.654.39-2.358 1.805-3.201 3.781-3.054 7.152 3.985 15.231 18.605 18.907z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    gradientUnits: "userSpaceOnUse",
    x1: 3620.358,
    y1: 2498.666,
    x2: 3567.725,
    y2: 2364.989,
    gradientTransform: "rotate(-34.208 1335.545 6013.434)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444b8c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#3e4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#Z)"
    },
    d: "M1122.747 1736.34s11.236 20.816 17.488 25.727c6.254 4.912 20.344 7.908 34.021.445 13.679-7.464 21.269-14.456 21.269-14.456s5.599 28.845 2.192 32.408c-3.406 3.567-28.626 19.008-35.873 17.914-7.248-1.094-24.945-15.375-29.041-24.215-4.096-8.839-9.028-31.79-9.028-31.79l-1.028-6.033z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsiReport);
export default __webpack_public_path__ + "static/media/fsi-report.92ff2048b5e9d96f03123d7bb3a29914.svg";
export { ForwardRef as ReactComponent };